import React, { useContext } from "react";
import "./ExploreDropdown.css";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";

const ExploreDropDown = ({ isOpen, onMouseEnter, onMouseLeave }) => {
  const { texts } = useContext(LanguageContext);

  return (
    <div
      className={`explore-dropdown ${isOpen ? "open" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="explore-links">
        <Link to="/events" className="explore-item">
          {texts.navbar.eventsActivities}
        </Link>
        <Link to="/companyProfile" className="explore-item">
          {texts.navbar.distributorProfile}
        </Link>
        <Link to="/ourShowrooms" className="explore-item">
          {texts.navbar.ourShowrooms}
        </Link>
      </div>
    </div>
  );
};

export default ExploreDropDown;
